import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/problema-aviso",

        async list({ pagination }) {
            const url = this.url(
                `/${pagination.page}/${pagination.amountPerPage}`
            );

            return await Vue.http.get(url, {
                params: {}
            });
        },

        async count() {
            const url = this.url(`/paginacao`);

            return await Vue.http.get(url, {
                params: {}
            });
        }
    },
    base
);
